import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'

export const ItemCategoryMasterPopup = (props) => {
    return (
        <ModalBasic
            id="processMaster"
            classParams="!w-[55%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Item category</span>
                <div className='item-grp grid grid-cols-3 gap-2.5 mt-3 mb-3'>
                    <div className='input-grp'>
                        <label>Item category no</label>
                        <TextInput type='number'
                            id='itemCategoryNo' name='itemCategoryNo'
                            value={props.itemObject.itemCategoryNo}
                            handleChange={(event) => props.handleChange(event, 'itemCategoryNo')}
                            disabled
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Select type</label>
                        <MultiSelectDropdown
                            drpIdentity="Select type"
                            options={props.itemObject.types}
                            value={props.itemObject.selectedTypeId ? props.itemObject.types.find(x => x.value === props.itemObject.selectedTypeId) : 0}
                            onChange={(event) =>
                                props.handleChangeFroDropdown(event, "selectedTypeId")
                            }
                        />
                    </div>
                    <div className='input-grp col-span-3'>
                        <label>Item group</label>
                        <MultiSelectDropdown
                            drpIdentity="Select item group"
                            options={props.itemObject.itemGrp}
                            value={props.itemObject.itemGrpId ? props.itemObject.itemGrp.find(x => x.value === props.itemObject.itemGrpId) : 0}
                            onChange={(event) =>
                                props.handleChangeFroDropdown(event, "itemGrpId")
                            }
                        />
                    </div>
                    <div className='input-grp col-span-3'>
                        <label>Item category name</label>
                        <TextInput type='text'
                            id='itemCategoryName' name='itemCategoryName'
                            value={props.itemObject.itemCategoryName}
                            handleChange={(event) => props.handleChange(event, 'itemCategoryName')}
                            className={props.validState?.error?.itemCategoryName !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-3'>
                        <label>Item category description</label>
                        <TextInput type='text'
                            id='itemCategoryDesc' name='itemCategoryDesc'
                            value={props.itemObject.itemCategoryDesc}
                            handleChange={(event) => props.handleChange(event, 'itemCategoryDesc')}
                        />
                    </div>
                    <div className='input-grp col-span-3'>
                        <label>Remarks</label>
                        <TextInput type='text'
                            id='remarks' name='remarks'
                            value={props.itemObject.remarks}
                            handleChange={(event) => props.handleChange(event, 'remarks')}
                        />
                    </div>
                </div>
                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()}>Save</button>
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}